import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../hooks/useStores.tsx";
import TableLayout, { TableRow } from "../../../../layout/TableLayout/TableLayout.tsx";
import { ITopImages } from "../../../../models/attribution-reports.ts";
import { showErrorToast } from "../../../../utils/toast.tsx";
import styles from "./TopImages.module.scss";
import TopImagesTable from "./TopImagesTable.tsx";

const TopImages = () => {
	const { t } = useTranslation("translation", { keyPrefix: "account.attributionReports" });
	const { attributionReportsStore } = useAppStore();
	const [topImagesTableData, setTopImagesTableData] = useState<TableRow<ITopImages>[]>([]);
	const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
	const tableHeaders = t("tables.topImages.headers", { returnObjects: true }) as string[];

	useEffect(() => {
		const loadTopHitsData = async () => {
			if (!attributionReportsStore.isTopHitsImagesDataLoading && !attributionReportsStore.topImagesData.length) {
				try {
					await attributionReportsStore.loadTopHitsImagesData();
				} catch (e: any) {
					showErrorToast(t("pleaseTryAgainLater"));
				}
			}
		};
		loadTopHitsData();
	}, [attributionReportsStore.selectedDateRange]);

	useEffect(() => {
		const loadTopPaidData = async () => {
			if (
				!attributionReportsStore.isTopImagesDataLoading &&
				attributionReportsStore.topImagesData.length &&
				!attributionReportsStore.topImagesData[0].topPaid?.length
			) {
				try {
					await attributionReportsStore.loadTopPaidImagesData();
				} catch (e: any) {
					showErrorToast(t("pleaseTryAgainLater"));
				}
			}
		};
		loadTopPaidData();
	}, [attributionReportsStore.topPaidImagesPPGFile]);

	useEffect(() => {
		setIsTableLoading(true);
		setTopImagesTableData(
			attributionReportsStore.topImagesData.map((data: ITopImages) => {
				return {
					rowStyle: {},
					data: data,
				};
			}),
		);
		setIsTableLoading(false);
	}, [attributionReportsStore.topImagesData]);

	useEffect(() => {
		attributionReportsStore.setSelectedTab(t("tabs.topImages"));
	}, []);

	return (
		<Box className={styles.topImagesTable}>
			<TableLayout
				hideHeader={true}
				headerArray={tableHeaders}
				tableData={topImagesTableData}
				customTable={TopImagesTable}
				loading={
					attributionReportsStore.isTopHitsImagesDataLoading ||
					attributionReportsStore.isTopImagesDataLoading ||
					isTableLoading
				}
				emptyStateComponent={<Typography>{t("tables.partnersEarnings.emptyState")}</Typography>}
			/>
		</Box>
	);
};

export default observer(TopImages);
